import React from 'react';
import { IssueItem } from '../../models/issueItem';
import SortableTable, { ColumnDefinition } from '../common/SortableTable';
import './IssuesTable.css';
import { useNavigate } from 'react-router-dom';
import { useIssue } from '../../contexts/IssueContext';

interface IssuesTableProps {
  issues: IssueItem[];
}

const IssuesTable: React.FC<IssuesTableProps> = ({ issues }) => {
  const navigate = useNavigate();
  const { setSelectedIssue } = useIssue();
  const columns: ColumnDefinition<IssueItem>[] = [ // Use IssueItem here
    { key: 'id', label: 'ID', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'start_at', label: 'Start At', sortable: true },
    { key: 'end_at', label: 'End At', sortable: true },
    { key: 'count', label: 'Count', sortable: true },
    { key: 'link', label: 'Link', sortable: false,
       render: (item: IssueItem) =>  (
        <a href={item.link} target="_blank" rel="noopener noreferrer">
          {item.link}
        </a>
      )
     },

   
  ];

  const handleRowClick = (issue: IssueItem) => { // Use IssueItem here
    console.log( `sending out the issue ${issue.id}`)
    setSelectedIssue( issue);
    navigate(`/issue/${issue.id}`);
  };

  return (
      <div className="issues-table">
          <SortableTable data={issues} columns={columns} onRowClick={handleRowClick} rowIdKey={'id'}/>
      </div>
  );
};

export default IssuesTable;
